import configs from '@/config'
import Constant from '@/constant'
import { getVariant } from '@/vuex/modules/featureToggles.module'
import i18nPresenter from '@/i18nPresenter'
import { ROUTE_NAMES } from '@/constant/routes'
import { SYSTEM_STATUS_BAR_DEFAULT_MESSAGE, SYSTEM_STATUS_BAR_FLAG } from '@/constant/systemStatus.constant'
import { buildStatusPageAnnouncement } from '@/services/statusPageNotice'

const SET_GET_CONFIGURATION_ERROR = 'SET_GET_CONFIGURATION_ERROR'
const SET_LOADING_CONFIGURATION = 'SET_LOADING_CONFIGURATION'
const SET_CONFIGURATION = 'SET_CONFIGURATION'
const SET_SYSTEM_STATUS_ACTIVE = 'SET_SYSTEM_STATUS_ACTIVE'

const SYSTEM_STATUS_CRITICAL_LEVEL = 3
const SYSTEM_STATUS_HIDDEN_ROUTE_NAMES = [
  ROUTE_NAMES.LOGIN,
  ROUTE_NAMES.REGISTER,
  ROUTE_NAMES.FORGOT_PASSWORD,
  ROUTE_NAMES.SSO,
  ROUTE_NAMES.OAUTH,
  ROUTE_NAMES.AUTH,
  ROUTE_NAMES.GOOGLE_ONE_TAP_LANDING,
  ROUTE_NAMES.MICROSOFT_AUTH,
  ROUTE_NAMES.ONBOARDING_WELCOME,
]

const _state = {
  configuration: {},
  isLoadingConfiguration: false,
  getConfigurationError: null,
  isSystemStatusActive: false,
}

const getters = {
  configuration(state) {
    return state.configuration
  },
  isLoadingConfiguration(state) {
    return state.isLoadingConfiguration
  },
  getConfigurationError(state) {
    return state.getConfigurationError
  },
  isEURegion() {
    return configs.region === Constant.euRegion
  },
  announcement(state, __, rootState, rootGetters) {
    const routeName = rootState.route && rootState.route.name
    if (rootGetters['featureToggles/isFeatureEnabled'](SYSTEM_STATUS_BAR_FLAG)) {
      const isHiddenRoute = SYSTEM_STATUS_HIDDEN_ROUTE_NAMES.includes(routeName)
      const statusPageAnnouncement = !isHiddenRoute && buildStatusPageAnnouncement({
        isSystemStatusActive: state.isSystemStatusActive,
        defaultMessage: i18nPresenter.t(SYSTEM_STATUS_BAR_DEFAULT_MESSAGE),
      })
      if (statusPageAnnouncement) return statusPageAnnouncement
    }
    if (state.isSystemStatusActive && !SYSTEM_STATUS_HIDDEN_ROUTE_NAMES.includes(routeName)) {
      return {
        content: i18nPresenter.t(SYSTEM_STATUS_BAR_DEFAULT_MESSAGE),
        criticalLevel: SYSTEM_STATUS_CRITICAL_LEVEL,
      }
    }
    const { payload } = getVariant(rootGetters, 'public-announcement')
    if (payload?.value) {
      return JSON.parse(payload.value)
    }
    return null
  },
}

const actions = {
  setSystemStatusAnnouncement: ({ commit }) => commit(SET_SYSTEM_STATUS_ACTIVE, true),
  clearSystemStatusAnnouncement: ({ commit }) => commit(SET_SYSTEM_STATUS_ACTIVE, false),
  getConfiguration: async ({ commit }) => {
    commit(SET_LOADING_CONFIGURATION, true)
    try {
      let url = configs.configFile
      if (configs.region === 'eu') {
        url = `${configs.cloudfrontPublic}/configurations/${configs.env === 'production' ? 'config' : 'config-dev'}-eu.json`
      }
      const res = await fetch(`${url}?v=${Date.now()}`)
        .then((r) => r.json())
        .then((body) => ({ body }))
      commit(SET_CONFIGURATION, res.body)
      commit(SET_GET_CONFIGURATION_ERROR, null)
    } catch (error) {
      // Không cần làm gì kể cả khi có lỗi, có thể coi đây là lỗi từ 3rd party service khi gọi đến CloudFront Url có vấn đề, kể cả việc show thông báo lỗi cho user cũng ko cần luôn.
      // Nên có thể nuốt lỗi ở đây.
      commit(SET_GET_CONFIGURATION_ERROR, error)
    } finally {
      commit(SET_LOADING_CONFIGURATION, false)
    }
  },
}

const mutations = {
  [SET_CONFIGURATION](state, config) {
    state.configuration = config
    state.getConfigurationError = null
  },
  [SET_SYSTEM_STATUS_ACTIVE](state, isSystemStatusActive) {
    state.isSystemStatusActive = isSystemStatusActive
  },
  [SET_LOADING_CONFIGURATION](state, isLoadingConfiguration) {
    state.isLoadingConfiguration = isLoadingConfiguration
  },
  [SET_GET_CONFIGURATION_ERROR](state, error) {
    state.getConfigurationError = error
  },

}

export default {
  namespaced: true,
  state: _state,
  getters,
  actions,
  mutations,
}
